if (!customElements.get('bv-header')) {
  customElements.define('bv-header', class extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.bv-header__toggle');
      this.nav = this.querySelector('.bv-nav');
      if (!this.toggle || !this.nav) return;
      this.setAttribute('data-enhanced', '');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 1199px)');
      this.toggle.addEventListener('click', () => this.setOpen(!this.hasAttribute('data-menu-open')), options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]');
        if (details && this.nav.contains(details)) {
          details.open = false;
          details.querySelector('summary').focus();
        } else if (this.hasAttribute('data-menu-open')) {
          this.setOpen(false);
          this.toggle.focus();
        }
        event.preventDefault();
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, options);
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, options);
      this.nav.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        if (!summary) return;
        const current = summary.parentElement;
        for (const item of current.parentElement.parentElement.children) {
          const sibling = item.querySelector(':scope > details');
          if (sibling && sibling !== current) sibling.open = false;
        }
      }, options);
      this.updatePosition = () => {
        this.style.setProperty('--bv-nav-top', `${Math.max(0, this.getBoundingClientRect().bottom)}px`);
        if (!this.mobile.matches && this.hasAttribute('data-menu-open')) this.setOpen(false);
      };
      this.observer = new ResizeObserver(this.updatePosition);
      this.observer.observe(this);
      window.addEventListener('resize', this.updatePosition, options);
      window.addEventListener('scroll', this.updatePosition, { ...options, passive: true });
      this.updatePosition();
    }
    setOpen(open) {
      this.toggleAttribute('data-menu-open', open);
      this.toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('bv-menu-open', open);
      if (!open) this.nav.querySelectorAll('details[open]').forEach(details => { details.open = false; });
    }
    closeAll() { this.setOpen(false); }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      document.body.classList.remove('bv-menu-open');
    }
  });
}
